import { render, staticRenderFns } from "./InvestorCalculatorSetting.vue?vue&type=template&id=52311cd6&"
import script from "./InvestorCalculatorSetting.vue?vue&type=script&lang=js&"
export * from "./InvestorCalculatorSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports